









































import Vue from "vue";
import _ from "lodash";
import { Rules } from "@ct/validations";
import RESET_PASSWORD_MUTATION from "@/graphql/ResetPasswordMutation.gql";
import { ResetPasswordMutation, ResetPasswordMutationVariables } from "@/graphql/generatedTypes/ResetPasswordMutation";
import { AlertBar } from "@ct/alert";

export default Vue.extend({
  name: "ResetPassword",
  components: { AlertBar },
  computed: {
    passwordsMatch(): string {
      return this.password === this.passwordConfirmation ? "" : "Passwords must match";
    }
  },
  data() {
    return {
      password: "",
      passwordConfirmation: "",
      rules: Rules
    };
  },
  methods: {
    async submitReset() {
      (this.$refs.form as HTMLFormElement).validate();
      const { password, passwordConfirmation } = this;

      try {
        const result = await this.$apollo.mutate<ResetPasswordMutation, ResetPasswordMutationVariables>({
          mutation: RESET_PASSWORD_MUTATION,
          variables: {
            reset: {
              password,
              passwordConfirmation,
              token: this.$route.params.token
            }
          }
        });

        if (_.isEmpty(result.data?.resetPassword?.errors)) {
          await this.$alertService.addAlert({
            message: "Your password has been reset please login again",
            type: "success"
          });
        } else {
          await this.$alertService.addAlert({ message: "An Error has occurred", type: "error" });
        }
      } catch (e) {
        await this.$alertService.addAlert({ message: "An Error has occurred", type: "error" });
      }
    }
  },
  mounted() {
    if (this.$route.query.ct === "true") {
      window.location = `${process.env.VUE_APP_CT_URL}/password_resets/${this.$route.params.token}/edit` as any;
    }
  }
});
